function extractQueryParamFromPageURL() {
    const params = {};
    try {
        const searchParams = new URLSearchParams(window.location.search);

        for (const [key, value] of searchParams.entries()) {
            params[key] = value;
        }
    } catch (e) {}

    return params;
}

function setUTMParameters() {
    try {
        const queryParams = extractQueryParamFromPageURL();

        // ✅ Safe mapping
        const paramMapping = {
            "gad_source": "utm_source",
            "gad_campaignid": "utm_campaign",
            "ref": "utm_source"
        };

        const allowedUTMs = [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_content",
            "utm_term",
            "gclid",
            "fbclid",
            "shpxid",
            "gbraid"
        ];

        let newData = {};

        Object.keys(queryParams).forEach(key => {
            let finalKey = key;

            if (paramMapping[key]) {
                finalKey = paramMapping[key];
            }

            // ✅ Don't overwrite real UTMs with mapped ones
            if (
                allowedUTMs.includes(finalKey) &&
                (!newData[finalKey] || key === finalKey)
            ) {
                newData[finalKey] = queryParams[key];
            }
        });

        if (Object.keys(newData).length > 0) {
            localStorage.setItem("utmTracker", JSON.stringify(newData));
        }
    } catch (e) {}
}

setUTMParameters();